module.exports = __webpack_public_path__ + "img/time@3x.3b46d78a.jpg";